module.exports = __webpack_public_path__ + "img/power-off-white.649053fd.svg";